const getApiBase = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  const isCapacitor = window.location.protocol === 'capacitor:' || window.location.protocol === 'file:';
  if (isCapacitor) return 'http://REPLACE_WITH_YOUR_IP:8000/api/v1';
  return '/api/v1';
};

export const API_BASE = getApiBase();
export const API_ROOT = API_BASE.startsWith('http') ? API_BASE.split('/api/v1')[0] : '';
